// extracted by mini-css-extract-plugin
export default {"pureGrid":"DemoPerformance_pureGrid__k3XP9","gridingg":"DemoPerformance_gridingg__B4jDR","playbtn":"DemoPerformance_playbtn__p5err"};